// @flow
import styled from 'styled-components';
import PropTypes from 'prop-types';

import type { Screen } from '../../typings';
import packageJson from '../../../../package.json';
import opacityRevealKeyframes from '../../../keyframes/opacityRevealKeyframes';
import DisplayText from '../Text/DisplayText';
import { SMALL_DEVICE_WIDTH, SMALL_DEVICE_HEIGHT } from '../../../constants';
import logo from '../../../assets/svg/Misc/logo.svg';
import logoBrand from '../../../assets/svg/Misc/logo-brand.svg';

const FixedLogoContainer = styled.div`
  position: absolute;
  top: 60px;
  left: 110px;
  pointer-events: none;
  z-index: 7;
  animation: ${opacityRevealKeyframes} 0.3s ease-in-out;

  @media (max-height: ${SMALL_DEVICE_HEIGHT}px) {
    top: 8px;
    left: 30px;
  }

  @media (max-width: ${SMALL_DEVICE_WIDTH}px) {
    display: ${props => (props.isFormView ? 'block' : 'none')};
  }
`;

const VersionContainer = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: space-between;
  width: 115px;
`;

type Props = {
  isUserLoggedIn: boolean,
  screenWidth: number,
  screen: Screen | null,
  kioskSessionId: number | null
};

export default function FixedLogo({ isUserLoggedIn, screen, screenWidth, kioskSessionId }: Props) {
  const isFormView = !isUserLoggedIn || screen || screenWidth > SMALL_DEVICE_WIDTH;
  const logoSrc = isFormView ? logo : logoBrand;
  const themeColor = isFormView ? 'whiteText' : 'brand';

  return (
    <FixedLogoContainer isFormView={isFormView}>
      <img src={logoSrc} alt="sling" />
      <VersionContainer>
        <DisplayText bold themeColor={themeColor}>
          {kioskSessionId}
        </DisplayText>
        <DisplayText bold themeColor={themeColor}>
          {packageJson.version}
        </DisplayText>
      </VersionContainer>
    </FixedLogoContainer>
  );
}

FixedLogo.propTypes = {
  isUserLoggedIn: PropTypes.bool,
  screen: PropTypes.string,
  screenWidth: PropTypes.number
};
